import { render, staticRenderFns } from "./Novedades.vue?vue&type=template&id=aa7f89da&"
import script from "./Novedades.vue?vue&type=script&lang=js&"
export * from "./Novedades.vue?vue&type=script&lang=js&"
import style0 from "./Novedades.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports